import ax from "axios";

const  axios = ax.create({
    baseURL: 'https://vi-connect-e-commerce-api.onrender.com'
})

export default axios;